import React from "react";

const LegalPageLayout = ({
  title,
  lastUpdated,
  headerExtra,
  sections,
  activeSection,
  onSectionClick,
  children,
}) => {
  return (
    <div className="min-h-screen bg-brand-cream">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col lg:flex-row gap-8">
          <aside className="lg:w-64 flex-shrink-0">
            <div className="sticky top-8 card-board p-4">
              <h2 className="heading-display text-lg mb-4">Contents</h2>
              <nav className="space-y-1">
                {sections.map((section) => (
                  <button
                    key={section.id}
                    type="button"
                    onClick={() => onSectionClick(section.id)}
                    className={`block w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${
                      activeSection === section.id
                        ? "bg-brand-charcoal text-brand-cream font-display font-bold"
                        : "text-brand-muted hover:text-brand-charcoal hover:bg-brand-cream"
                    }`}
                  >
                    {section.title}
                  </button>
                ))}
              </nav>
            </div>
          </aside>

          <div className="flex-1 max-w-4xl">
            <div className="card-board overflow-hidden">
              <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
                <h1 className="font-display font-bold text-xl md:text-2xl text-brand-cream tracking-tight">
                  {title}
                </h1>
                {lastUpdated ? (
                  <p className="text-sm text-brand-mist mt-1">
                    Last updated {lastUpdated}
                  </p>
                ) : null}
              </div>
              <div className="p-6 md:p-8 space-y-12 text-brand-charcoal leading-relaxed">
                {headerExtra}
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalPageLayout;
